
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Pin',
	'find_label': 'Suchen',
	'findCancelLabel': 'Abbrechen',
	'dataPaneLabel': 'Daten',
	'sourcePaneLabel': 'Ausgewählte Quellen',
	'sourcePaneContentLabel': 'Quelle auswählen',
	'emptySourcePaneTitle': 'Quelle auswählen',
	'emptySourcePaneCaption': 'Auf die Option zum Auswählen einer Quelle klicken, um Daten hinzuzufügen, die zur Erstellung eines Dashboards verwendet werden sollen.',
	'addDataSource': 'Quelle auswählen',
	'addDataDashboardCoachMarkContents': 'Ziehen Sie Daten aus dem Datenfenster in das Dashboard und legen Sie sie ab.',
	'addDataStoryCoachMarkContents': 'Ziehen Sie Daten aus dem Datenfenster in die Story und legen Sie sie ab.',
	'addDataCoachMarkTitle': 'Daten hinzufügen',
	'selectSourcesText': 'Datenquelle auswählen und hinzufügen für die Erstellung von: %{app}.',
	'selectSourcesLabel': 'Quelle auswählen',
	'dataPreparationTitle': 'Datenaufbereitung',
	'dataPreparationCaption': 'Daten werden hier angezeigt, wenn die Datenaufbereitung abgeschlossen ist.',
	'dataPreparationProgress': '%{percentage}% vorbereitet...',
	'dataPreparationSourceError': 'Die Datenaufbereitung für "%{sourceName}" wurde nicht erfolgreich abgeschlossen.',
	'dataPreparationStarted': 'Die Datenaufbereitung für "%{sourceName}" ist in Bearbeitung. Dashboard-Features sind nach Abschluss der Datenaufbereitung verfügbar.',
	'dataPreparationComplete': 'Die Datenaufbereitung für "%{sourceName}" ist abgeschlossen. Sie kann jetzt mit allen Dashboardfunktionen verwendet werden.',
	'preparingData': 'Daten werden vorbereitet...',
	'moserUnsupportedSourceType': 'Dieser Datenquellentyp wird nicht unterstützt.',
	'errorSourcesTitle': 'Laden der Datenverzeichnisstruktur fehlgeschlagen',
	'errorLoadingDataSources': 'Beim Laden der Liste mit Datasets ist ein Fehler aufgetreten',
	'errorLoadingDataTree': 'Beim Laden der Verzeichnisstruktur ist ein Fehler aufgetreten',
	'dataSetPaneLastUpdated': 'Letzte Aktualisierung: %{date}',
	'dataSourcePaneDateUnknown': 'Unbekannt',
	'moreTitle': 'Mehr',
	'backLabel': 'Zurück',
	'addDataSourceDialogTitle': 'Quelle auswählen',
	'addDataSourceDialogButtonLabel': 'Hinzufügen',
	'dlg_use': 'Verwenden',
	'dlg_RelinkDataSourceTitle': 'Dataset "%{dataSourceName}" ersetzen durch...',
	'propertiesDialogTitle': 'Eigenschaften',
	'missingDataSetData': 'Die Daten für dieses Dataset sind nicht verfügbar. Aktualisieren Sie das Dataset oder wenden Sie sich an den Administrator, um Zugriff auf die Quelle zu erhalten.',
	'errorMessageTitle': 'Fehler',
	'calculation_navigation_in_use': 'Wenn Berechnungen, Filter oder Navigationspfade gelöscht werden, werden alle Visualisierungen, die sich auf das gelöschte Element beziehen, ungültig. Soll das Element gelöscht werden?',
	'delete_confirm': 'Löschen bestätigen',
	'previewUnavailable': 'Die Datenablage und die globalen Filter sind für diesen Packagetyp nicht verfügbar.',
	'contextualGridTabName': 'Visualisierungsdaten',
	'DATA_TRAY_no_data_text': 'Sie haben derzeit keine Daten',
	'contextualGridMenuLabel': 'Visualisierungsdatenmenü',
	'contextualGridExport': 'Exportieren',
	'nullValueText': 'Null',
	'relationships_title': 'Beziehungen',
	'forecastDetailsTabName': 'Prognose - Statistikdetails',
	'forecastDetailsModelLabel': 'Modell',
	'forecastDetailsQualityMetricLabel': 'Genauigkeitskennzahlen',
	'forecastDetailsSmoothingCoefLabel': 'Parameter',
	'forecastDetailsDiagnostics': 'Diagnosen',
	'forecastDetailsForecastLabel': 'Prognose',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Genauigkeit %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Saisonalität',
	'forecastDetailsSeasonalPeriodLabel': 'Saisonaler Zeitraum',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Fehlende Anzahl',
	'forecastDetailsSeriesLengthLabel': 'Länge der Zeitreihe',
	'forecastDetailsIgnoredPeriods': 'Ignorierte Zeiträume',
	'forecastDetailsTrendStrength': 'Trendstärke',
	'forecastDetailsSeasonalityStrength': 'Saisonalitätsstärke',
	'forecastDetailsTimeDeltaUnit': 'Datums-/Zeitintervall',
	'forecastDetailsNotes': 'Anmerkungen',
	'DatasetRefresh_AmbiguousConnection': ' Verwenden Sie \'Datensatz bearbeiten\', um das Verbindungsproblem %{errorMessage} zu lösen'
});
